import { FieldLabel, TextInput } from '../../components/Primitives.jsx';
import { Segmented } from '../StepInspector.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';

export function ParseBoolInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <FieldLabel>Truthy values</FieldLabel>
      <TextInput mono value={c.truthy || 'true, yes, y, 1, t'} onChange={(v) => u({ truthy: v })} />
      <FieldLabel>Falsy values</FieldLabel>
      <TextInput mono value={c.falsy || 'false, no, n, 0, f'} onChange={(v) => u({ falsy: v })} />
      <FieldLabel hint="If a value matches neither">On unknown</FieldLabel>
      <Segmented
        value={c.onUnknown || 'keep'}
        onChange={(v) => u({ onUnknown: v })}
        options={[
          { value: 'keep', label: 'Leave as string' },
          { value: 'null', label: 'Set null' },
          { value: 'false', label: 'Coerce false' },
        ]}
      />
    </div>
  );
}
